import React from 'react'

import { faListCheck } from '@fortawesome/pro-regular-svg-icons/faListCheck'
import { faListCheck as faListCheckSolid } from '@fortawesome/pro-solid-svg-icons/faListCheck'

import MainMenuItem from 'src/components/Menu/MainMenuItem'

import useTranslations from 'src/hooks/useTranslations'
import { reverse } from 'src/routes/config'

export default function TaskCenterMenu({ parentIsCollapsed }) {
    const { t } = useTranslations('TaskCenterMenu', 'TaskCenterMenu')

    return (
        <MainMenuItem
            icon={faListCheck}
            iconActive={faListCheckSolid}
            title={t('Task center')}
            to={reverse('task-center')}
            parentIsCollapsed={parentIsCollapsed}
        />
    )
}
